import { API_BASE } from './platform.ts';
import { getToken } from './session.ts';

/** Fire-and-forget product analytics (stored on our own server). */
export function track(name: string, props?: Record<string, unknown>) {
  try {
    const token = getToken();
    void fetch(`${API_BASE}/api/events`, {
      method: 'POST',
      keepalive: true,
      headers: { 'content-type': 'application/json', ...(token ? { authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ name, props }),
    }).catch(() => {});
  } catch {
    // never let analytics break the app
  }
}
